// Plan areas — how findings are grouped for a reviewer.
//
// A reviewer's question is "what is this about", not "how was it produced".
// Evidence strength stays a badge and a filter; the grouping is the part of the
// plan the finding sits in. The mapping itself lives in the taxonomy, next to
// the failure modes it describes; only the labels are here.

import type { FailureModeId, PlanAreaId } from '../types';
import { TAXONOMY } from './taxonomy';

export const PLAN_AREA_LABELS: Record<PlanAreaId, string> = {
  'savings-arithmetic': 'Savings arithmetic',
  'baseline-and-witnessing': 'Baseline and witnessing',
  'assumptions-and-stipulations': 'Assumptions and stipulations',
  'adjustments-and-what-happens-later': 'Adjustments and what happens later',
  'om-and-budget': 'O&M and budget',
  'data-of-record-and-disputes': 'Data of record and disputes',
  'references-and-definitions': 'References and definitions',
};

export const PLAN_AREA_IDS = Object.keys(PLAN_AREA_LABELS) as PlanAreaId[];

export function planAreaLabel(id: PlanAreaId): string {
  return PLAN_AREA_LABELS[id];
}

/** Which failure modes sit in each area, read off the taxonomy. */
export const MODES_BY_PLAN_AREA: Record<PlanAreaId, FailureModeId[]> =
  PLAN_AREA_IDS.reduce(
    (acc, area) => {
      acc[area] = TAXONOMY.failure_modes
        .filter((fm) => fm.planArea === area)
        .map((fm) => fm.id);
      return acc;
    },
    {} as Record<PlanAreaId, FailureModeId[]>,
  );
